import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'kan-editor',
    templateUrl: './component.html',
    styleUrls: ['./component.scss']
})
export class kanEditor {
    @Input() public value: string = '';
    @Output() public valueChange: EventEmitter<any> = new EventEmitter<any>();

    constructor() {
    }

    ngOnInit(): void {
    }

    public onChange(event) {
        this.valueChange.emit(event);
    }
}



// WEBPACK FOOTER //
// ./src/modules/common/components/editor/component.ts